import { render } from "./BatchOperation.vue?vue&type=template&id=65855da7&scoped=true"
import script from "./BatchOperation.vue?vue&type=script&lang=js"
export * from "./BatchOperation.vue?vue&type=script&lang=js"

import "./BatchOperation.vue?vue&type=style&index=0&id=65855da7&scoped=true&lang=less"
import "./BatchOperation.vue?vue&type=style&index=1&id=65855da7&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65855da7"]])

export default __exports__